import * as RESOURCES from '@constants/resources';
import * as CONST from '@constants/variables';

export const authorizationObject = {
    [RESOURCES.SDI_ORIGIN_ENTRY_POINTS]: CONST.SECURITY_PRIVILEGES_READ,
};
